import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';

const DoctorResetPassword = React.lazy(() =>
  import('../../views/DoctorResetPassword')
);

const params = [];
const DoctorResetPasswordRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<></>} footer={<></>}>
        <DoctorResetPassword />
      </Layout>
    </RouteParameter>
  );
};

DoctorResetPasswordRoute.propTypes = {};

DoctorResetPasswordRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(DoctorResetPasswordRoute);
